<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <input
        type="text"
        class="form-control"
        id="form-field-{{ formField.id }}"
        inputmode="numeric"
        appNumberValidator
        appFocus
        [appAutoFocus]="formField.isNeedToFocus"
        [attr.name]="formField.name || formField.id"
        [name]="formField.name || formField.id"
        [placeholder]="formField.placeholder"
        [(ngModel)]="formField.value"
        [required]="formField.isRequired"
        (input)="onInput(inputElement)"
        [minlength]="minLength"
        (keydown)="onKeyDown($event)"
        (paste)="onPaste($event)"
        (drop)="onDrop($event)"
        #inputElement
        #field="ngModel" />

    @if (formService.isSubmitted && field.errors?.validateNumber?.invalid) {
        <div class="text-danger" translate>Invalid number</div>
    }

    @if (formService.isSubmitted && field.value && field.errors?.minlength) {
        <div class="text-danger"><span translate>Minimum number of digits is </span>{{ minLength }}</div>
    }

    @if (formService.isSubmitted && !formField.value && formField.isRequired) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
